const PROJECT_DATA = [
  {
    id: 1,
    name: "Face De-occlusion GAN",
    image: "https://robohash.org/AKD.png?set=set2",
    link: "https://github.com/sonuuno2020/Face-De-occlusion-GAN",
    about:
      "It is a project with GAN , which creates de-occluded face image for a image with occlusion.",
  },
  {
    id: 2,
    name: "E-Commerce",
    image: "https://robohash.org/AKD.png?set=set9",
    link: "https://github.com/sonuuno2020/e_commerce",
    about: "It is an e-commerce website for fashion related goods.",
  },
  {
    id: 3,
    name: "AI Vision",
    image: "https://robohash.org/AKD.png?set=set4",
    link: "https://github.com/sonuuno2020/AI-Vision/",
    about:
      "This project contains two computer vision problems that is multiclass classification problem.",
  },
];

export default PROJECT_DATA;
